<template>
  <div
    class="organism popular-neighborhoods pt-8 sm:pt-[76px] pb-[104px] px-8"
    :style="'background-color:' + organism.backgroundColor"
  >
    <h2
      class="font-archer text-gray-800 text-3xl sm:text-[40px] text-center max-w-xl mx-auto font-semibold mb-12 leading-none"
    >
      You may also be interested in these neighborhoods:
    </h2>
    <ul class="popular-item-group">
      <li class="" v-for="item in organism.items">
        <MoleculesOverviewItem :item-raw-data="item" :plans="organism.plans" />
      </li>
    </ul>
  </div>
</template>

<style>
.popular-neighborhoods {
  .popular-item-group {
    @apply flex gap-8 flex-wrap max-w-screen-xl mx-auto justify-center items-start;
  }

  article {
    @apply max-w-md m-0 p-0;

    header {
      @apply bg-white drop-shadow-lg m-0 gap-0 sm:gap-2 xl:gap-7;

      > figure {
        @apply !h-[204px];

        img {
          @apply !h-[204px];
        }
      }

      .item-text {
        @apply px-[18px] sm:pl-0 py-4 sm:pr-4 self-start;
      }
    }
  }

  .explore-button {
    @apply hidden;
  }
}
</style>

<script setup>
const props = defineProps({
  organism: Object,
});
</script>
